import React from 'react';
import { Button, Tooltip } from '@chakra-ui/react';
import { MdOpenInNew } from 'react-icons/md';

/**
 * Navigation Link Component
 * Opens external links in new tab with configurable styling
 *
 * @param {string} url - URL to open
 * @param {string} label - Button label
 * @param {ReactNode} icon - Left icon
 * @param {string} size - Button size (default: 'sm')
 * @param {string} variant - Button variant (default: 'outline')
 * @param {string} colorScheme - Color scheme (default: 'blue')
 * @param {...any} props - Any additional Button props for custom styling
 */
const NavigationLink = ({
  url,
  label,
  icon,
  size = 'sm',
  variant = 'outline',
  colorScheme = 'blue',
  ...props
}) => {
  const handleClick = () => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Tooltip label={`${label} (opens in new tab)`} placement="top">
      <Button
        size={size}
        colorScheme={colorScheme}
        variant={variant}
        leftIcon={icon}
        rightIcon={<MdOpenInNew size={14} />}
        onClick={handleClick}
        {...props}
      >
        {label}
      </Button>
    </Tooltip>
  );
};

export default NavigationLink;
